<template>
  <div class="dynamic-attr-text" :class="(attrObj.isCheckError?'is-check-error':'')">
      <div
        :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
        :style="{fontSize:$pScreen.titleS}"
      >
        <span>{{attrObj.title}}</span>
        <span style="color:#C3C3C3;display:block">单选题</span>
      </div>
      <div class="check-content">
        <div
          v-for="(item,index) in attrObj.optionList"
          :key="index"
          class="radio-options"
          :style="{fontSize:$pScreen.textS}"
        >
          <div v-if="attrObj.disabled" class="disabledRadio"></div>
          <div class="radio-options-content" @click="selectAttr(index)">
            <div class="radio-options-value">
              <Icon
                style="font-size: 16px;vertical-align:middle;"
                type="text"
                notTimeout
                :icon="item._isSelect?'check-square':'square'"
                :class="item._isSelect?'selected':''"
                :disabled="attrObj.disabled"
              ></Icon>
            </div>
            <div class="radio-options-label">
              <span>{{item.optionContent}}</span>
            </div>
          </div>
        </div>
        <div v-if="attrObj.isCheckError" class="errorTip">请选择选项</div>
      </div> 
  </div>
</template>

<script>
export default {
  props: {
    attrObj: Object
  },
  data() {
    return {};
  },
  created() {
    let self = this;
    this.attrObj.optionList.filter(function(item){
      self.$set(item, "_isSelect", !!item._isSelect)
    });
    // item => this.$set(item, "_isSelect", false)
  },
  //初始化后调用
  mounted: function() {

  },
  methods: {
    selectAttr(index) {
      let self=this
      this.attrObj.optionList.filter(item => (self.$set(item, "_isSelect", false)));
      this.attrObj.optionList[index]._isSelect = true;
    },
    //关闭
    handleClose() {
      let tabItemName = this.$parent.name;
      this.$emit("handleClose", tabItemName);
    }
  }
};
</script>
<style>
  .radio-options{
    position: relative;
     margin-top: 10px;
  }
  .disabledRadio{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 666;
  }
  .radio-options-content {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .radio-options-label {
    margin-left: 5px;
  }
  .errorTip {
    width: 100%;
  }
  .check-content {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/radio.vue